import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductCrossReferenceComponent } from './product-cross-reference.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageTitle } from '../store-front/misc/page-title/page-title.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule, IconModule } from '@spartacus/storefront';
import { productCrossReferenceOccConfig } from './core/product-cross-reference.occ';
import { ProductCrossReferenceTableComponent } from './components/product-cross-reference-table/product-cross-reference-table.component';
import { ScreenViewModule } from '../../../core/directives/screen-view/_screen-view.module';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipIconComponent } from '../../../components/tooltip-icon/tooltip-icon.component';
import { RouterModule } from '@angular/router';
import { AlertComponent } from '../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../components/loader/local-loader/local-loader.component';

@NgModule({
  declarations: [ProductCrossReferenceComponent, ProductCrossReferenceTableComponent],
  imports: [
    CommonModule,
    PageTitle,
    I18nModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    FormErrorsModule,
    ScreenViewModule,
    IconModule,
    TooltipModule,
    TooltipIconComponent,
    AlertComponent,
    LocalLoaderComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductCrossReferencePageComponent: {
          component: ProductCrossReferenceComponent,
        },
      },
    }),
    provideConfig(productCrossReferenceOccConfig),
  ],
})
export class ProductCrossReferenceModule {}
